import { useQuery } from '@tanstack/react-query'
import { ApiError, api } from '../api/client'

/** Whether drafted replies are switched on. The probe 404s when the flag is
 *  off; any other failure is thrown (and retried) so a network blip never
 *  flips the console back to the old compose path. */
export function useRepliesEnabled() {
  return useQuery({
    queryKey: ['replies-enabled'],
    queryFn: () =>
      api.get('/api/replies/known-issues').then(
        () => true,
        (err: unknown) => {
          if (err instanceof ApiError && err.status === 404) return false
          throw err
        },
      ),
    staleTime: 5 * 60 * 1000,
  })
}
